var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.simple)?_c('h1',{staticClass:"mb-6"},[_vm._v(_vm._s(_vm.text))]):_c('div',{staticClass:"d-flex align-center mb-6"},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }